<template>
    <span class="lang-de"><the-text-view :value="value"/></span>
</template>

<script>


    import TheTextView from './TheTextView'


    export default {
        name: 'TheGerman',
        components: {
            TheTextView
        },
        data() {
            return {

            }
        },
        props: {
            value: String
        }
    }
</script>